import styles from "./text-editor.module.css";
import Editor, {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  BtnStyles,
  BtnUnderline,
  type ContentEditableEvent, // Import the correct event type here
  Toolbar,
} from "react-simple-wysiwyg";

import { useEffect, useRef, useState } from "react";

interface RichTextEditorComponentProps {
  label?: string;
  name?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  value?: string;
}

export function RichTextEditorComponent({
  label,
  name = "",
  onChange,
  placeholder = "Start typing...",
  value = "",
}: RichTextEditorComponentProps) {
  const [editorValue, setEditorValue] = useState(value);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setEditorValue(value);
  }, [value]);

  // Use the correct event type here
  const handleEditorChange = (event: ContentEditableEvent) => {
    const newValue = event.target.value;
    setEditorValue(newValue);
    onChange?.(newValue);
  };

  const handleImageSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const imageUrl = reader.result as string;
        const imageHtml = `<img src="${imageUrl}" alt="uploaded-image" style="max-width:100%; height:auto; margin:8px 0;" />`;
        const updatedContent = editorValue + imageHtml;
        setEditorValue(updatedContent);
        onChange?.(updatedContent);
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  return (
    <div className={styles.container}>
      {label && <p>{label}</p>}

      <Editor
        value={editorValue}
        className={styles.editor}
        name={name}
        onChange={handleEditorChange}
        placeholder={placeholder}
      >
        <Toolbar>
          <BtnBold />
          <BtnItalic />
          <BtnBulletList />
          <BtnUnderline />
          <BtnLink />
          <BtnNumberedList />
          <BtnStyles />
          <BtnClearFormatting />

          {/* Custom Image Upload Button */}
          <button
            className={styles.toolbarButton}
            onClick={handleImageSelect}
            title="Insert Image"
          >
            📷
          </button>

          {/* Hidden File Input */}
          <input
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
            style={{ display: "none" }}
            type="file"
          />
        </Toolbar>
      </Editor>
    </div>
  );
}
